import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function About() {
  return (
    <div
      className='mt-10  '
      id='about'
    >
      <div className='grid md:grid-cols-2 grid-cols-1 md:gap-5 gap-10'>
        <AnimateOnScroll animation='flipIn'>
          <div className='flex md:justify-start justify-center'>
            <img
              src='/images/about.png'
              alt='about'
              className=' md:h-[311px] h-[270px]'
            />
          </div>
        </AnimateOnScroll>
        <div className='space-y-4 relative'>
          <img
            src='/images/ellipse.png'
            alt='about'
            className='  mx-auto absolute top-0  left-0 w-[300px] h-[300px]'
          />
          <AnimateOnScroll animation='flipIn'>
            <div className='bg-black border border-[#FFFFFF1F] text-[#FF8A3D] text-center rounded-full w-28 py-2 px-5'>
              <h5>About Us</h5>
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <h1 className='md:text-5xl text-3xl font-semibold'>
              Tools AI Introduction
            </h1>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <p className='font-light'>
              Welcome to ToolsAI, an innovative blockchain trading assistant
              designed to elevate your trading experience. Leveraging advanced
              AI technology & seamlessly integrated with the Ethereum
              blockchain, ToolsAI offers powerful tools that streamline trading.
              Our bot is crafted using sophisticated algorithms & secure coding
              practices, guaranteeing reliability & efficiency. With ToolsAI,
              you have access to real-time analytics, security scans, &
              community management features, making it an essential tool for
              every crypto trader.
            </p>
          </AnimateOnScroll>
        </div>
      </div>
    </div>
  )
}
